import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Kicker } from "./bits";
import { T } from "./content";
import { useNoIndex } from "./hooks";

function MaskedTitle({ lines }) {
  return (
    <h1 className="display">
      {lines.map((line, li) => (
        <div className="line-mask" key={li}>
          <span>
            {line.map((seg, si) =>
              si % 2 === 1 ? (
                <em key={si} className="accent">
                  {seg}
                </em>
              ) : (
                seg
              )
            )}
          </span>
        </div>
      ))}
    </h1>
  );
}

export default function AdhesionConfirmee({ lang }) {
  const t = T[lang];
  useNoIndex();

  return (
    <main className="site" data-testid="adhesion-confirm-main">
      <section className="section adhesion-confirm">
        <div className="container">
          <div className="adh-confirm__inner reveal">
            <Kicker withDash>{t.confirmKicker}</Kicker>
            <MaskedTitle lines={t.confirmTitle} />
            <p className="lead adh-confirm__p">{t.confirmP1}</p>
            <p className="lead adh-confirm__p">{t.confirmP2}</p>

            <div className="adh-confirm__sign">
              <span className="adh-confirm__name">{t.confirmSignName}</span>
              <span className="adh-confirm__role">{t.confirmSignRole}</span>
            </div>

            <Link className="adh-back" to="/" data-testid="adhesion-confirm-back">
              <ArrowLeft size={15} strokeWidth={1.4} />
              {t.confirmBack}
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
